import { render, staticRenderFns } from "./Contabilizar.vue?vue&type=template&id=47b93dcc"
import script from "./Contabilizar.vue?vue&type=script&lang=js"
export * from "./Contabilizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports